<mat-menu #suggestionsMenu="matMenu" [hasBackdrop]="true" xPosition="before" class="suggestions-menu">
  <h3 class="suggestions-menu__title">
    {{ 'suggestions.articlesSuggested' | translate: { n: userService.purchaseSuggestions.length } }}
  </h3>
  <mat-action-list>
    <button
      mat-list-item
      (click)="$event.stopPropagation()"
      *ngFor="let suggestion of userService.purchaseSuggestions.slice(0, 5)"
      disableRipple="true">
      <div class="suggestions-menu__icon">
        <span class="odilo-icon">{{ suggestion.icon.icon }}</span>
      </div>

      <div class="suggestions-menu__info">
        <h3 mat-line>{{ suggestion.title }}</h3>
        <span mat-line>{{ suggestion.author }}</span>
      </div>
      <button
        class="suggestions-menu__delete"
        mat-icon-button
        (click)="handleSuggestionToDelete(suggestion)"
        [opacTooltip]="'common.delete' | translate"
        [attr.aria-label]="'common.delete' | translate">
        <span class="odilo-icon" aria-hidden="true">delete</span>
      </button>
    </button>

    <button mat-list-item (click)="goToUserSuggestions()" class="suggestions-menu__view-all">
      <mat-icon mat-list-icon><span class="odilo-icon">suggestions</span></mat-icon>
      <p mat-line>{{ 'results.suggestions.viewAll' | translate }}</p>
    </button>
  </mat-action-list>
</mat-menu>

<div class="themed-dialog purchase-suggestions-dialog">
  <div class="dialog__header">
    <div class="dialog__header__title">
      <h2 class="title__text" tabindex="0">
        {{ 'results.suggestions.title' | translate }}
      </h2>
      <span class="title__count" *ngIf="userService.purchaseSuggestions.length" [matMenuTriggerFor]="suggestionsMenu">
        {{ userService.purchaseSuggestions.length }}
      </span>

      <button
        mat-flat-button
        *ngIf="!open"
        class="only-icon title__close"
        (click)="dialogRef.close()"
        [attr.aria-label]="'common.close' | translate">
        <span class="odilo-icon" aria-hidden="true">close</span>
      </button>
    </div>

    <div class="dialog__header__search">
      <div class="searchbar-terms-wrapper">
        <div class="search__bar">
          <form (submit)="addTerm(query.value)">
            <mat-form-field>
              <input
                type="text"
                required
                #query
                matInput
                disableRipple="true"
                [attr.aria-label]="'tooltip.search' | translate" />
              <button
                matSuffix
                mat-icon-button
                [disabled]="query.value === ''"
                [attr.aria-label]="'tooltip.search' | translate">
                <mat-icon aria-hidden="true">search</mat-icon>
              </button>
            </mat-form-field>
          </form>
        </div>

        <div class="search__terms">
          <mat-chip-list *ngIf="searchModel" [attr.aria-label]="'searches.title' | translate">
            <mat-chip
              *ngFor="let term of searchModel.terms"
              [selectable]="false"
              [removable]="true"
              (keydown.enter)="removeTerm(term)"
              (keydown.space)="removeTerm(term)"
              [attr.aria-label]="term.term"
              (removed)="removeTerm(term)">
              <span class="odilo-icon" aria-hidden="true">{{ term.icon }}</span>
              <span aria-hidden="true">{{ term.term }}</span>
              <span matChipRemove class="odilo-icon close-icon" aria-hidden="true">close</span>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>

      <div class="suggestions-wrapper">
        <div
          class="search__suggestions"
          *ngIf="userService.purchaseSuggestions.length"
          [matMenuTriggerFor]="suggestionsMenu"
          tabindex="0">
          <span class="search__suggestions__text">{{ 'results.suggestions.yourSuggestions' | translate }}</span>
          <span class="search__suggestions__count">{{ userService.purchaseSuggestions.length }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="loading-animation" *ngIf="searching">
    <div class="animation-row">
      <div class="double-bounce">
        <div class="child double-bounce1"></div>
        <div class="child double-bounce2"></div>
      </div>
    </div>
  </div>

  <div class="dialog__content">
    <div class="left-wrapper" *ngIf="result?.total">
      <div class="dialog__content__toolbar">
        <div class="toolbar__results" tabindex="0">
          <p>
            <span>{{ 'results.title' | translate }}</span>
            <span>{{ result.total }}</span>
          </p>

          <button mat-flat-button class="accent transparent" (click)="open = true">
            {{ 'sidebar.title' | translate }}
          </button>
        </div>

        <div class="toolbar__formats">
          <div class="format-filter-wrapper">
            <ng-container *ngFor="let elem of formatFilter.values">
              <button
                mat-flat-button
                class="btn-icon-text"
                [opacTooltip]="getFormatInfo(elem.name).key | translate"
                [class.selected]="elem.selected"
                tabindex="0"
                [attr.aria-label]="(getFormatInfo(elem.name).key | translate) + ' ' + elem.value"
                (keydown.enter)="applyFilter(formatFilter.name, elem.name)"
                (keydown.space)="applyFilter(formatFilter.name, elem.name)"
                (click)="applyFilter(formatFilter.name, elem.name)">
                <span class="odilo-icon filter-icon" aria-hidden="true">{{ getFormatInfo(elem.name).icon }}</span>
                <span class="text" aria-hidden="true">{{ elem.value }}</span>
              </button>
            </ng-container>
          </div>
        </div>
      </div>

      <div>
        <app-record-card-grid>
          <app-purchase-suggestions-item
            *ngFor="let record of result.records"
            [record]="record"
            [deleted]="cancelledRecordId"
            [requestedBy]="record.requestedBy"
            [alreadyInLibrary]="record.inLibrary"
            [solutionType]="solutionType"></app-purchase-suggestions-item>
        </app-record-card-grid>
      </div>

      <div class="dialog__content__more" [ngClass]="textDirection">
        <button mat-flat-button class="accent" *ngIf="hasLoadMore" (click)="loadMore()" [class.waiting]="waiting">
          <ng-container *ngIf="!waiting"> {{ 'results.suggestions.moreResults' | translate }} </ng-container>

          <mat-spinner *ngIf="waiting" [diameter]="30"></mat-spinner>
        </button>
      </div>
    </div>

    <div class="right-wrapper">
      <div class="dialog__sidebar" [class.open]="open" *ngIf="result?.total">
        <div class="dialog__sidebar__header">
          <h2 class="header__title">{{ 'sidebar.title' | translate }}</h2>
          <button mat-flat-button class="only-icon header__close" (click)="open = false">
            <span class="odilo-icon">close</span>
          </button>
        </div>

        <div class="dialog__sidebar__content">
          <mat-accordion displayMode="flat" multi="true">
            <ng-container *ngFor="let filter of filters">
              <mat-expansion-panel [expanded]="true" *ngIf="filter.values.length">
                <mat-expansion-panel-header collapsedHeight="36px" expandedHeight="36px">
                  {{ filter.label }}
                </mat-expansion-panel-header>

                <div class="mat-expansion-panel__list">
                  <ng-container *ngFor="let item of getExpandedValues(filter.values)">
                    <div
                      class="expansion-panel__item"
                      [class.selected]="item.selected"
                      tabindex="0"
                      [attr.aria-label]="
                        (adapt(filter, item) | translate) +
                        ' ' +
                        item.value +
                        ' ' +
                        ('common.items' | translate)
                      "
                      (keydown.enter)="applyFilter(filter.name, item.name)"
                      (keydown.space)="applyFilter(filter.name, item.name)"
                      (click)="applyFilter(filter.name, item.name)">
                      <div class="wrapper">
                        <span aria-hidden="true">{{ adapt(filter, item) | translate }}</span>
                        <span class="count" aria-hidden="true">{{ item.value }}</span>
                      </div>

                      <span *ngIf="item.selected" class="odilo-icon" aria-hidden="true">close</span>
                    </div>
                  </ng-container>

                  <div class="mat-expansion-panel__list__nested" [class.collapsed]="!filter.expanded">
                    <div *ngFor="let item of getCollapsedValues(filter.values)">
                      <div
                        class="expansion-panel__item"
                        [class.selected]="item.selected"
                        [tabIndex]="filter.expanded ? 0 : -1"
                        [attr.aria-label]="
                          (adapt(filter, item) | translate) +
                          ' ' +
                          item.value +
                          ' ' +
                          ('common.items' | translate)
                        "
                        (keydown.enter)="applyFilter(filter.name, item.name)"
                        (keydown.space)="applyFilter(filter.name, item.name)"
                        (click)="applyFilter(filter.name, item.name)">
                        <div class="wrapper">
                          <span aria-hidden="true">{{ adapt(filter, item) | translate }}</span>
                          <span class="count" aria-hidden="true">{{ item.value }}</span>
                        </div>

                        <span *ngIf="item.selected" class="odilo-icon" aria-hidden="true">close</span>
                      </div>
                    </div>
                  </div>
                </div>

                <span
                  *ngIf="hasViewMore(filter.values)"
                  class="mat-expansion-panel__more"
                  tabindex="0"
                  [attr.aria-label]="filter.action | translate"
                  (keydown.enter)="toggleValuesPanel(filter)"
                  (keydown.space)="toggleValuesPanel(filter)"
                  (click)="toggleValuesPanel(filter)">
                  <span class="odilo-icon" aria-hidden="true">{{ filter.icon }}</span>
                  <span class="expansion-panel-text" aria-hidden="true">{{ filter.action | translate }}</span>
                </span>
              </mat-expansion-panel>
            </ng-container>
          </mat-accordion>
        </div>
      </div>
    </div>

    <opac-no-results *ngIf="!searching && !result?.total" [label]="'results.noResults' | translate">
      <opac-no-results-results slot="custom-svg"></opac-no-results-results>
    </opac-no-results>
  </div>
</div>

<opac-confirmation-dialog
  [acceptLabel]="'common.delete'"
  [cancelLabel]="'common.cancel'"
  [open]="showDeleteSuggestionDialog()"
  [title]="'results.suggestions.cancel' | translate"
  (accept)="deleteSuggestion()"
  (cancel)="showDeleteSuggestionDialog.set(false)">
  <p>{{ 'suggestions.cancelConfirmation.body' | translate }}</p>
</opac-confirmation-dialog>